import React, { useEffect, useState, useRef } from "react";
import { fetchData, convertToSlug } from "../../components/api"; // Import fetchData function from your API file
import Banner from "../Banner/Banner";
import parse from "html-react-parser";
import './PropertyServices.css';

const BASEURL = process.env.REACT_APP_SOMPROP_BASE_URL;
const SALONAPI = process.env.REACT_APP_SOMPROP_API_EXTERNAL;

function PropertyServices() {
  const [propertyServices, setPropertyServices] = useState("");
  const [totalData, setTotalData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [whyChooseSPI, setWhyChooseSPI] = useState(null);
  const [propertyloading, setpropertyloading] = useState(false)
  const [loadingText, setloadingText] = useState(false)
const [loadingTextAPI, setloadingTextAPI] = useState(false)
  const sectionRef = useRef(null);

  useEffect(() => {
    const apiUrl = `${SALONAPI}/why_choose_spi`;

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        setWhyChooseSPI(data.website_settings.why_choose_spi && (data.website_settings.why_choose_spi || ''));
        setloadingTextAPI(true)
      })
      .catch((error) => {
        console.error("Error fetching why choose SPI data:", error);
      });
  }, []);

  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  useEffect(() => {
    const apiUrl = `${SALONAPI}/property_services`;

    fetchData(apiUrl).then((data) => {
        setPropertyServices(data.website_settings.property_services && (data.website_settings.property_services || ''));
        setloadingText(true)
      })
      
      .catch((error) => {
        console.error("Error fetching property services:", error);
      });

    fetch(`${SALONAPI}/galleryDataList`)
      .then((response) => response.json())
      .then((data) => {
        let tabName = [
          `${BASEURL}/images/building-icon.svg`,
          `${BASEURL}/images/bulldozer-icon.svg`,
          `${BASEURL}/images/positive_dynamic-icon.svg`,
          `${BASEURL}/images/key-icon.svg`,
          `${BASEURL}/images/investment-icon.svg`,
          `${BASEURL}/images/Accounting.svg`,
          `${BASEURL}/images/Land-Planning-and-Property-Consulting.svg`,
        ];
        const formattedData = data.map((item, index) => ({
          ...item,
          main_image: tabName[index],
        }));
        setTotalData(formattedData);
        setSelectedItem(formattedData[0]);
        setpropertyloading(true)
      })
      .catch((error) => {
        console.error("Error fetching gallery data:", error);
      });
  }, []);

  const scrollToSection = () => {
    if (sectionRef.current) {
      const windowWg = window.innerWidth;
      const elementPosition = sectionRef.current.getBoundingClientRect().top;
      const offsetPosition = window.pageYOffset + elementPosition - (windowWg > 575 ? 290 : 130);

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };
  return (
    <div>
      <Banner></Banner>
      <div className="container">
        
        {
          loadingText ? (<div className="property-services-content"  dangerouslySetInnerHTML={{ __html: propertyServices }}></div>): (<div className="shimmer-main" style={{marginTop:'85px',marginBottom:'50px'}}>
            
            <div className="shimmer" style={{width:'100%',height:'16px',display:'block',marginRight:'15px',marginBottom:'16px',borderRadius:'5px'}}></div>
          <div className="shimmer" style={{width:'95%',height:'16px',display:'block',marginRight:'15px',marginBottom:'16px',borderRadius:'5px'}}></div>
          <div className="shimmer" style={{width:'92%',height:'16px',display:'block',marginRight:'15px',marginBottom:'16px',borderRadius:'5px'}}></div>
          <div className="shimmer" style={{width:'85%',height:'16px',display:'block',marginRight:'15px',marginBottom:'16px',borderRadius:'5px'}}></div> </div>)
        }
      
      </div>
      
      <div className="our-services-section">
        <div className="container">
        <h2>Our Services</h2>
        {
        propertyloading ? ( <ul className="nav nav-tabs" id="myTab" role="tablist">
          {totalData && totalData.map((item, index) => (
            <li className="nav-item" role="presentation" key={index} onClick={scrollToSection}>
              <button
                className={`nav-link ${selectedItem === item ? "active" : ""}`}
                onClick={() => handleItemClick(item)}
              >
                <span>
                  <img
                    src={item.main_image}
                    width="30"
                    height="39"
                    alt="building icon"
                  />
                </span>
                {item.gallery_title}
              </button>
            </li>
          ))}
        </ul>) : (<div className="shimmer-main row" style={{marginTop:'20px',marginBottom:'20px'}}>

        <div className="shimmer" style={{width:'181px',height:'90px',display:'block',marginRight:'15px'}}></div>
        <div className="shimmer" style={{width:'181px',height:'90px',display:'block',marginRight:'15px'}}></div>
        <div className="shimmer" style={{width:'181px',height:'90px',display:'block',marginRight:'15px'}}></div>
        <div className="shimmer" style={{width:'181px',height:'90px',display:'block',marginRight:'15px'}}></div>
        <div className="shimmer" style={{width:'181px',height:'90px',display:'block',marginRight:'15px'}}></div>
        <div className="shimmer" style={{width:'181px',height:'90px',display:'block',marginRight:'15px'}}></div>

        <br/>

        <div className="shimmer-grid row" style={{margin:'50px auto', maxWidth:'719px',width:'100%'}}>
           <div className="shimmer-half shimmer" style={{width:'47%',marginRight:'20px', display:'block',minHeight:'300px'}}></div>
           <div className="shimmer-half shimmer" style={{width:'47%',marginRight:'20px', display:'block',minHeight:'300px'}}></div>
        </div>
        
        </div>)
        }
        
       
        <div className="tab-content" id="myTabContent" ref={sectionRef}>
          {totalData.map((item, index) => (
            <div
              className={`tab-pane fade ${
                selectedItem === item ? "show active" : ""
              }`}
              id={convertToSlug(item.gallery_title)}
              role="tabpanel"
              aria-labelledby={`${convertToSlug(item.gallery_title)}-tab`}
              key={index}
            >
              <div className="our-services-gird">
                <div className="row">
                  <div className="col-md-6 col-sm-6 col-12">
                    {
                    propertyloading ? (<div className="our-services-img">
                      <img
                        src={item.gallery_image}
                        width="348"
                        height="259"
                        alt={convertToSlug(item.gallery_title)}
                      />
                    </div>) : (<div className="shimmer" style={{height:'328px',width:'100%',display:'block'}}></div>)
                    }
                    
                  </div>
                  <div className="col-md-6 col-sm-6 col-12">
                    <div className="our-services-content">
                    {
                     propertyloading ? (<div className="our-services-box">
                     <p>{item.gallery_description}</p>
                   </div>) : (<div className="shimmer-main">
                    
                    <div className="shimmer-parent" style={{minHeight:'291px',display:'block',width:'100%'}}>
                      
                      <div className="shimmer" style={{height:'20px',display:'block',width:'300px',marginBottom:'12px'}}></div>
                      <div className="shimmer" style={{height:'20px',display:'block',width:'300px%',marginBottom:'12px'}}></div>
                      <div className="shimmer" style={{height:'20px',display:'block',width:'250px',marginBottom:'12px'}}></div>
                      <div className="shimmer" style={{height:'20px',display:'block',width:'200px',marginBottom:'12px'}}></div>
                      <br/><br/>
                      <div className="shimmer" style={{height:'20px',display:'block',width:'300px',marginBottom:'12px'}}></div>
                      <div className="shimmer" style={{height:'20px',display:'block',width:'300px%',marginBottom:'12px'}}></div>
                      <div className="shimmer" style={{height:'20px',display:'block',width:'250px',marginBottom:'12px'}}></div>

                    </div></div>)

                    }
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>


      {whyChooseSPI && (
        <div className="container">
          {loadingTextAPI ? (<div className="why-choose-spi">{parse(whyChooseSPI)}</div> ) : (<div className="shimmer-main" style={{marginTop:'85px',marginBottom:'50px'}}>
            
            <div className="shimmer" style={{width:'100%',height:'16px',display:'block',marginRight:'15px',marginBottom:'16px',borderRadius:'5px'}}></div>
          <div className="shimmer" style={{width:'95%',height:'16px',display:'block',marginRight:'15px',marginBottom:'16px',borderRadius:'5px'}}></div>
          <div className="shimmer" style={{width:'92%',height:'16px',display:'block',marginRight:'15px',marginBottom:'16px',borderRadius:'5px'}}></div>
          <div className="shimmer" style={{width:'85%',height:'16px',display:'block',marginRight:'15px',marginBottom:'16px',borderRadius:'5px'}}></div> </div>)}
        </div>
      )}
        </div>
    </div>
  );
}



export default PropertyServices;
